export const getPhoneParts = (phone) => {
  const [countryCode = "", number = ""] = (phone ?? "").split(" ");

  return { countryCode: countryCode || "+1", number };
};

export const isIncompletePhone = (phone) =>
  typeof phone === "string" && getPhoneParts(phone).number.length !== 10;
